import { ModalType, ModalPropsMap } from 'types/modals'
import { LoginModal } from 'components/modals/LoginModal'
import { RegisterModal } from 'components/modals/RegisterModal'
import { ResetPasswordModal } from 'components/modals/ResetPasswordModal'
import { OpenTicketModal } from 'components/modals/OpenTicketModal'
import { CloseTicketModal } from 'components/modals/CloseTicketModal'
import { OpenChatModal } from 'components/modals/OpenChatModal'
import { ExportChatModal } from 'components/modals/ExportChatModal'
import { CookiePreferencesModal } from 'components/modals/CookiePreferencesModal'
import React from 'react'

type ModalComponent<T extends ModalType> = React.FC<ModalPropsMap[T]>

export const ModalRegistry: { [K in ModalType]: ModalComponent<K> } = {
  [ModalType.LOGIN]: LoginModal as ModalComponent<ModalType.LOGIN>,
  [ModalType.REGISTER]: RegisterModal as ModalComponent<ModalType.REGISTER>,
  [ModalType.RESET_PASSWORD]: ResetPasswordModal as ModalComponent<ModalType.RESET_PASSWORD>,
  [ModalType.OPEN_TICKET]: OpenTicketModal as ModalComponent<ModalType.OPEN_TICKET>,
  [ModalType.CLOSE_TICKET]: CloseTicketModal as ModalComponent<ModalType.CLOSE_TICKET>,
  [ModalType.OPEN_CHAT]: OpenChatModal as ModalComponent<ModalType.OPEN_CHAT>,
  [ModalType.EXPORT_CHAT]: ExportChatModal as ModalComponent<ModalType.EXPORT_CHAT>,
  [ModalType.COOKIE_PREFERENCES]: CookiePreferencesModal as ModalComponent<ModalType.COOKIE_PREFERENCES>,
  [ModalType.CUSTOM]: ({ component }: { component: React.ReactNode }) => <>{component}</>,
}
